import {
  SET_NEW_OFFERS,
  SET_OFFERS,
  SET_REWARDS,
  SET_OFFER_MODAL_DATA,
  SET_OFFER_MODAL_STATUS,
  SET_REWARD_MODAL_DATA,
  SET_REWARD_MODAL_STATUS,
  SET_REWARDS_CATALOG,
  // TODO: import action types added later
} from './types'

function setNewOffers(newOffers) {
  return {
    type: SET_NEW_OFFERS,
    payload: {
      newOffers,
    },
  }
}

function setOffers(offers) {
  return {
    type: SET_OFFERS,
    payload: {
      offers,
    },
  }
}

function setRewards(rewards) {
  return {
    type: SET_REWARDS,
    payload: {
      rewards,
    },
  }
}

function setOfferModalData(offerModalData) {
  return {
    type: SET_OFFER_MODAL_DATA,
    payload: {
      offerModalData,
    },
  }
}

function setOfferModalStatus(offerModalStatus) {
  return {
    type: SET_OFFER_MODAL_STATUS,
    payload: {
      offerModalStatus,
    },
  }
}

function setRewardModalData(rewardModalData) {
  return {
    type: SET_REWARD_MODAL_DATA,
    payload: {
      rewardModalData,
    },
  }
}

function setRewardModalStatus(rewardModalStatus) {
  return {
    type: SET_REWARD_MODAL_STATUS,
    payload: {
      rewardModalStatus,
    },
  }
}

function setRewardsCatalog(rewardsCatalog) {
  return {
    type: SET_REWARDS_CATALOG,
    payload: {
      rewardsCatalog,
    },
  }
}

// TODO: add more action creators

export {
  setNewOffers,
  setOffers,
  setRewards,
  setOfferModalData,
  setOfferModalStatus,
  setRewardModalData,
  setRewardModalStatus,
  setRewardsCatalog,
  // TODO: export action creators added later
}
